import { ws } from "./common";

export async function getVapidKey() {
  const res = await ws(
    "GET",
    process.env.REACT_APP_ENDPOINT + "device/",
    null,
    null,
    true
  );
  const data = await res.data;
  return data.publicKey;
}

// Funzione per registrare il Service Worker e attivare le notifiche push
export async function registerPushNotifications({ setState = null } = {}) {
  if (!("serviceWorker" in navigator)) {
    console.error("Service Worker non supportato");
    return;
  }

  if (!setState) {
    if (Notification.permission === "granted") {
      console.log("Notifiche già accettate");
      return; // Le notifiche sono già attivate, non serve fare nulla
    } else if (Notification.permission === "denied") {
      console.log("Notifiche bloccate dall'utente");
      return; // Le notifiche sono state bloccate, non fare nulla
    }
  }

  const publicVapidKey = await getVapidKey(); // Ottieni la chiave dinamicamente

  const register = await navigator.serviceWorker.register("/serviceWorker.js", {
    scope: "/",
  });
  const subscription = await register.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
  });

  const res = ws(
    "POST",
    process.env.REACT_APP_ENDPOINT + "device/",
    null,
    subscription,
    true
  );
  if (res.error) {
    console.log(res.error);
  } else {
    console.log("Push Notifications Attivate!");
    if (typeof setState === "function") setState(true);
  }
}

// Funzione per convertire la chiave VAPID
export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
